import React from "react";

import Text from "@src/sharedComponents/Typography/Text";

import styles from "./MetricsSection.module.css";

interface MetricsSectionProps {
  title: string;
  icon: React.ReactNode;
}

const MetricsSection: React.FC<
  React.PropsWithChildren<MetricsSectionProps>
> = ({ children, title, icon }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.title}>
          <div className={styles.icon}>{icon}</div>
          <Text variant="title2">{title}</Text>
        </div>

        <div className={styles.metrics}>{children}</div>
      </div>
    </div>
  );
};

export default MetricsSection;
